import React, { useEffect, useState } from "react";
import {
  FooterContainer,
  FooterRow,
  OperationBtn,
  BalanceBtn,
  MainBtn,
} from "./FooterStyled";
import useBetOperations from "../../bets";
import currencies from "../../helpers/getCurrency";
export default ({
  bet,
  userInfo,
  handleAbove,
  handleBetAmount,
  gameIsOn,
  inactiveGame,
  cashout,
  isDisabled,
  stateRound,
  cardSymbol,
  handleStartRound,
  handleStepRound,
  handleEndRound,
  floorFigure,
  handleNotification,
  handleAboveAnimation,
  handleIsDisabled,
  handleCardChange,
  userSettings,
  gameStates,
  audio,
}) => {
  const { minBet, maxBet, curr, precision, maxWin } = userInfo;
  const [ubet, , , multiply, divide] = useBetOperations(
    bet,
    userSettings.volume,
    userSettings.sound,
    handleNotification,
    minBet,
    maxBet,
    curr,
    precision
  );

  const [winAmount, setWinAmount] = useState("");
  const [divideAnim, setdivideAnim] = useState(false);
  const [doubleXanim, setdoubleXanim] = useState(false);
  const [playBtnAnim, setplayBtnAnim] = useState(false);
  const [setbetAnim, setsetBetAnim] = useState(false);
  const [hiBtnAnim, sethiBtnAnim] = useState(false);
  const [loBtnAnim, setloBtnAnim] = useState(false);
  const [cashoutBtnAnim, setCashoutBtnAnim] = useState(false);
  const coeficients = {
    high: stateRound.hiCoef,
    low: stateRound.loCoef,
  };


  useEffect(() => {
    setWinAmount(bet * stateRound.currentCoef);
  }, [bet, stateRound]);

  useEffect(() => {
    handleBetAmount(ubet);
  }, [ubet, handleBetAmount]);

  const handleChoose = (e) => {
    handleStepRound(e);
  };

  const setAnimation = (a, b) => {
    if (a) {
      b(false);
      clearTimeout();
    } else {
      b(true);
      setTimeout(() => {
        b(false);
      }, 167);
    }
  };

  useEffect(() => {
    gameIsOn || inactiveGame ? setplayBtnAnim(false) : setCashoutBtnAnim(false);
  }, [gameIsOn, inactiveGame]);

  useEffect(() => {
    if (!isDisabled) {
      sethiBtnAnim(false);
      setloBtnAnim(false);
    }
  }, [isDisabled]);

  useEffect(() => {
    if (gameStates === "start") {
      setplayBtnAnim(true);
    }
  }, [gameStates]);

  const handleClick = () => {
    audio.play();
    if (gameStates === "started") {
      cashout && setCashoutBtnAnim(true);
      handleEndRound();
      cashout && audio.cashout();
    } else if (gameStates === "init" || gameStates === "end") {
      handleStartRound(ubet);
      setTimeout(() => {
        gameIsOn && setplayBtnAnim(false);
        inactiveGame && setplayBtnAnim(false);
      }, 167);
    }
  };

  const handleStep = (step) => {
    if (gameStates === "started") {
      handleCardChange(true);
      handleIsDisabled(true);
      audio.pick();
      switch (step) {
        case "HI":
          sethiBtnAnim(true);
          handleChoose("HI");
          break;
        case "LO":
          setloBtnAnim(true);
          handleChoose("LO");
          break;
        default:
          break;
      }
    } else if (gameStates === "init" || gameStates === "end") {
      switch (step) {
        case "HI":
          setAnimation(doubleXanim, setdoubleXanim);
          multiply();
          break;
        case "LO":
          setAnimation(divideAnim, setdivideAnim);
          divide();
          break;
        default:
          break;
      }
    }
  };


  useEffect(() => {
    if (Number(winAmount) >= Number(maxWin)) {
      handleNotification(`You Have Reached  Max Win Amount of ${maxWin + currencies[curr]}, you can't win anymore in this round so please, cash out and begin a new Round!`)
    }
  }, [winAmount, handleNotification, maxWin, curr])
  return (
    <FooterContainer gameIsOn={gameIsOn} disabled={isDisabled}>
      <FooterRow>
        <OperationBtn
          divide={divideAnim}
          loBtnAnim={isDisabled && loBtnAnim}
          gameIsOn={gameIsOn}
          disabled={gameStates !== "started" && gameStates !== "init"}
          onClick={() => !isDisabled && handleStep("LO")}
        >
          {gameIsOn ? (
            <div>
              <p>{cardSymbol === "A" && gameIsOn ? "SAME" : "LO"}</p>
              <span>{floorFigure(coeficients.low, 2)}x</span>
            </div>
          ) : (
            <p>1/2</p>
          )}
        </OperationBtn>
        <BalanceBtn
          setbet={setbetAnim}
          gameIsOn={gameIsOn}
          onClick={
            !gameIsOn
              ? () => {
                setAnimation(setbetAnim, setsetBetAnim);
                handleAboveAnimation(true);
                handleAbove("setBet");
                audio.goForward();
              }
              : null
          }
        >
          <p>
            {ubet}
          </p>
          <span>{currencies[curr]}</span>
        </BalanceBtn>
        <OperationBtn
          double={doubleXanim}
          hiBtnAnim={isDisabled && hiBtnAnim}
          gameIsOn={gameIsOn}
          disabled={gameStates !== "started" && gameStates !== "init"}
          onClick={() => !isDisabled && handleStep("HI")}
        >
          {gameIsOn ? (
            <div>
              <p>{cardSymbol === "K" && gameIsOn ? "SAME" : "HI"}</p>
              <span>{floorFigure(coeficients.high, 2)}x</span>
            </div>
          ) : (
            <p>2X</p>
          )}
        </OperationBtn>
      </FooterRow>
      <FooterRow>
        <MainBtn
          playBtn={playBtnAnim}
          cashoutBtn={cashoutBtnAnim && cashout}
          cashout={gameIsOn && cashout}
          gameIsOn={gameIsOn}
          disabled={
            gameStates === "start" ||
            gameStates === "cashout" ||
            gameStates === "step"
          }
          onClick={() => handleClick()}
        >
          <p>PLAY</p>
          <p>CASHOUT</p>
          <span>
            {winAmount ? floorFigure(winAmount, userInfo.precision) : null}
            {currencies[curr]}
          </span>
        </MainBtn>
      </FooterRow>
    </FooterContainer>
  );
};
